import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import _ from 'lodash';
import store from '@/store';
import ReportsService from '@/services/ReportsService';

function initialState() {
    return {
        CustomizationReportExcelFileName: null,
        CustomizationReportPDFFileName: null,
        dropDownObject: {
            fromDate: new Date(),
            cinema_name: null,
            cinema_id: null,
        },
        CutomizationReport: [],
        AllCutomizationReport: [],
        pdfrecord: '',
        excelrecord: ''
    }
}

const state = initialState();

const mutations = {
    SET_CUSTOMIZATION_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.dropDownObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.dropDownObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                break;
            case 'fromDate':
                state.dropDownObject.fromDate = payload['event'] ? payload['event'] : null;
                break;
            default: console.log('Advance Sales Report :( Sorry, we are enable to set value.');
        }
    },
    ON_RESET_CUSTOMIZATION_REPORT_STORE_STATE: (state, payload) => {
        // state = initialState();
        const s = initialState()
        Object.keys(s).forEach(key => {
            state[key] = s[key]
        })
    },
    SET_CUSTOMIZATION_REPORT_DATES: (state, payload) => {
        payload['name'] ? state.dropDownObject[payload.name] = payload['event'] ? payload.event : null : '';
    },

    SET_CUSTOMIZATION_REPORT_DATA: (state, payload) => {
        state.CutomizationReport = payload.Records || [];
        state.AllCutomizationReport = payload.AllRecords || [];
    },
    SET_CUSTOMIZATION_EXCEL_FILE_NAME: (state, payload) => {
        state.CustomizationReportExcelFileName = payload;
    },
    SET_CUSTOMIZATION_PDF_FILE_NAME: (state, payload) => {
        state.CustomizationReportPDFFileName = payload;
    },
}

const actions = {
    onCustomizationReportDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_CUSTOMIZATION_DROP_DOWN_VALUES', payload);
    },
    onCutomizationReportDateHandler: async ({ dispatch, commit, state }, payload) => {
        commit('SET_CUSTOMIZATION_REPORT_DATES', payload)
    },
    onResetCustomizationStoreState: async ({ dispatch, commit, state }, { ...payload }) => {
        await commit('ON_RESET_CUSTOMIZATION_REPORT_STORE_STATE');
    },
    onFetchCustomizationReport: async ({ dispatch, commit, state }, payload) => {
        // console.log('object');
        let request_payload = {}

        if (state.dropDownObject.cinema_id && state.dropDownObject.cinema_id != null) {
            request_payload = state.dropDownObject

            await commit('SET_CUSTOMIZATION_REPORT_DATA', [])
            let loader = Vue.$loading.show();

            await ReportsService.GetCutomizationReport(request_payload)
                .then(async (response) => {
                    loader.hide();
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        commit('SET_CUSTOMIZATION_REPORT_DATA', data)

                        await commit('SET_CUSTOMIZATION_EXCEL_FILE_NAME', data['ExcelName'] || null);
                        await commit('SET_CUSTOMIZATION_PDF_FILE_NAME', data['PDFName'] || null);
                    } else {
                        Vue.toasted.show(data.message);
                    }
                }).catch((error) => {
                    loader.hide();
                    Vue.toasted.show("Catch Error on Customization Report", error);
                });
        } else {
            Vue.toasted.show("Please select Cinema.");
        }
    },
}

const getters = {
    getCustomizationReportsSelectedCinema: state => state.dropDownObject.cinema_name,
    getCustomizationReportFromDate: state => state.dropDownObject.fromDate,
    getCustomizationReportData: state => state.CutomizationReport,
    getAllCustomizationData: state => state.AllCutomizationReport,
    // Get File name
    getCustomizationExcelFileName: state => state.CustomizationReportExcelFileName,
    getCustomizationPdfFileName: state => state.CustomizationReportPDFFileName,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/CustomizationReportStore.js